import React, {Component} from 'react';
import JobsFormContainer from './jobs/JobsFormContainer';
import JobsPage from './jobs/JobsPage.jsx';
import JobViewPageContainer from './jobs/view/JobViewPageContainer';
import ArticleViewPageContainer from './articles/view/ArticleViewPageContainer';
import {HashRouter as Router, Route, Link, Switch} from 'react-router-dom';
import ArticlesList from "./articles/ArticlesPage";
import UsersListContainer from "./users/UsersListContainer";
import UsersFormContainer from "./users/UsersFormContainer";
import ProductsPage from "./products/ProductsPage";
import ProductForm from "./products/ProductFormContainer";
import ProductViewPageContainer from "./products/view/ProductViewPageContainer";
import ServicePage from './services/ServicesPage';
import ServiceFormContainer from './services/ServiceFormContainer';
import ServiceViewContainer from './services/ServiceViewContainer';
import CoursesPage from "./venues-and-courses/CoursesPage";
import CoursesFormContainer from './venues-and-courses/CoursesFormContainer';
import ContactPersonPage from "./contact-person/ContactPersonPage";
import ContactPersonFormContainer from "./contact-person/ContactPersonFormContainer";
import CourseViewContainer from "./venues-and-courses/CourseViewContainer";
import Dashboard from "./dashboard/Dashboard";
import CertificatesPage from "./certificates/CertificatesPage";
import UserProfileContainer from "./users/UserProfileContainer";
import ArticleFormContainer from "./articles/ArticleFormContainer";
import SupplierCompetenciesContainer from "./supplier-competencies/SupplierCompetenciesContainer";
import CompaniesListContainer from "./company/list/CompaniesListContainer";
import SettingsFormContainer from "./settings/SettingsFormContainer";
import {authenticatedAccess, partnerAccess, memberAccess, fbgAccess, fbgWebMasterAccess, salesAccess,
    fbgWebMasterAndSalesAccess, superAdminAccess, allAccess,
    notMaskinstationerMini, notMaskinbladetUser, onlyMaskinstationerRegular, onlyMaskinstationer
} from '../services/access/index';
import UserProfileFormContainer from "./users/UserProfileFormContainer";
import UserDeletePage from './users/UserDeletePage';
import MachinesPage from './machines/MachinesPage';
import MachineFormContainer from './machines/MachineFormContainer';
import MachineViewPageContainer from './machines/view/MachineViewPageContainer';
import AnalyticsContainer from './analytics/AnalyticsContainer';
import ChartsExample from './charts/ChartsExample';
import PortalContactFormContainer from "./portal-contact/PortalContactFormContainer";
import PortalContactTableContainer from "./portal-contact/PortalContactTableContainer";
import DepartmentsFormContainer from "./departments/DepartmentsFormContainer";
import DepartmentsTableContainer from "./departments/DepartmentsTableContainer";
import TipsPage from './tips/TipsPage';
import TipFormContainer from './tips/TipFormContainer';
import CatalogsPage from './catalog/CatalogsPage';
import CatalogForm from './catalog/CatalogFormContainer';
import CategoryTypes from './categories/CategoryTypes';
import InterestsFormContainer from './interests/InterestsFormContainer';

import CompanyFormContainer from './company/CompanyFormContainer';

import NotFound from "./NotFound";
import PlaceholderError from "./common/PlaceholderError";
import TreeEditorContainer from "./editors/TreeEditorContainer";
import TreeEditorCompetenciesContainer from "./editors/TreeEditorCompetenciesContainer";
import ArticleCategoriesListContainer from './articles/category/ArticleCategoriesListContainer';
import ArticleCategoryForm from "./articles/category/ArticleCategoryForm";
import ArticleCategoryFormContainer from "./articles/category/ArticleCategoryFormContainer";
import GalleryPage from './galleries/GalleriesPage';
import GalleryFormContainer from './galleries/GalleryFormContainer';
import GalleryViewPage from './galleries/GalleryViewPage';
import GalleryImageFormContainer from './galleries/GalleryImageFormContainer';
import GalleryImageCropPage from './galleries/GalleryImageCropPage';
import GalleryImageRotatePage from './galleries/GalleryImageRotatePage';
import MachineRentalFormContainer from "./machine-rental/MachineRentalFormContainer";

import RentMachineCategoryPage from "./rent-machine/category/CategoryPage";
import RentMachineCategoryFormContainer from "./rent-machine/category/CategoryFormContainer";
import MachineRentalFormUpdateContainer from "./machine-rental/MachineRentalFormUpdateContainer";
import RentMachinePage from "./machine-rental/RentMachinePage";

import ParkMachineCategoryPage from "./park-machine/category/CategoryPage";
import ParkMachineCategoryFormContainer from "./park-machine/category/CategoryFormContainer";
import ParkMachinesPage from "./park-machine/park-machine/ParkMachinesPage";
import ParkMachineContainer from "./park-machine/park-machine/ParkMachineContainer";
import KeywordsPackPage from "./keywords-pack/KeywordsPackPage";
import KeywordsPackFormContainer from "./keywords-pack/KeywordsPackFormContainer";

const RoutesContainer = () => {
    return (
        <div className="container">
            <Switch>
                <Route exact path="/" component={Dashboard}/>
                <Route exact path="/nyhed" component={partnerAccess(notMaskinstationerMini(ArticlesList))}/>
                <Route exact path="/nyhed/skab" component={partnerAccess(notMaskinstationerMini(ArticleFormContainer))}/>
                <Route exact path="/nyhed/redigere/:id" component={partnerAccess(notMaskinstationerMini(ArticleFormContainer))}/>
                <Route exact path="/nyhed/vis/:id" component={partnerAccess(notMaskinstationerMini(ArticleViewPageContainer))}/>
                <Route exact path="/jobopslag" component={partnerAccess(notMaskinstationerMini(JobsPage))}/>
                <Route exact path="/jobopslag/:page(\d+)" component={partnerAccess(notMaskinstationerMini(JobsPage))}/>
                <Route exact path="/jobopslag/skab" component={partnerAccess(notMaskinstationerMini(JobsFormContainer))}/>
                <Route exact path="/jobopslag/redigere/:id" component={partnerAccess(notMaskinstationerMini(JobsFormContainer))}/>
                <Route exact path="/jobopslag/vis/:id" component={partnerAccess(notMaskinstationerMini(JobViewPageContainer))}/>
                <Route exact path="/kontaktperson/skab" component={partnerAccess(notMaskinstationerMini(ContactPersonFormContainer))}/>
                <Route exact path="/kontaktperson/redigere/:id" component={partnerAccess(notMaskinstationerMini(ContactPersonFormContainer))}/>
                <Route exact path="/kontaktpersoner" component={partnerAccess(notMaskinstationerMini(ContactPersonPage))}/>
                <Route exact path="/user/profil" component={authenticatedAccess(UserProfileContainer)}/>
                <Route exact path="/user/profil/:userId/rediger" component={authenticatedAccess(UserProfileFormContainer)}/>
                <Route exact path="/ydelse" component={partnerAccess(notMaskinstationerMini(ServicePage))}/>
                <Route exact path="/ydelse/skab" component={partnerAccess(notMaskinstationerMini(ServiceFormContainer))}/>
                <Route exact path="/ydelse/redigere/:id" component={partnerAccess(notMaskinstationerMini(ServiceFormContainer))}/>
                <Route exact path="/ydelse/vis/:id(\d+)" component={partnerAccess(notMaskinstationerMini(ServiceViewContainer))}/>
                <Route exact path="/kurser" component={partnerAccess(notMaskinstationerMini(CoursesPage))}/>
                <Route exact path="/kurser/skab" component={partnerAccess(notMaskinstationerMini(CoursesFormContainer))}/>
                <Route exact path="/kurser/rediger/:id(\d+)" component={partnerAccess(notMaskinstationerMini(CoursesFormContainer))}/>
                <Route exact path="/profil/certifikater" component={partnerAccess(notMaskinstationerMini(CertificatesPage))}/>
                <Route exact path="/kurs/vis/:id(\d+)" component={partnerAccess(notMaskinstationerMini(CourseViewContainer))}/>
                // Catalogs
                <Route exact path="/kataloger" component={partnerAccess(CatalogsPage)}/>
                <Route exact path="/kataloger/skab" component={partnerAccess(CatalogForm)}/>
                <Route exact path="/kataloger/rediger/:id(\d+)" component={partnerAccess(CatalogForm)}/>

                <Route exact path="/produkt" component={partnerAccess(notMaskinstationerMini(ProductsPage))}/>
                <Route exact path="/produkt/skab" component={partnerAccess(notMaskinstationerMini(ProductForm))}/>
                <Route exact path="/produkt/redigere/:id" component={partnerAccess(notMaskinstationerMini(ProductForm))}/>
                <Route exact path="/produkt/vis/:id" component={partnerAccess(notMaskinstationerMini(ProductViewPageContainer))}/>
                <Route exact path="/leverandør-kompetencer" component={partnerAccess(notMaskinstationerMini(SupplierCompetenciesContainer))}/>
                <Route exact path="/brugere" component={fbgWebMasterAccess(UsersListContainer)}/>
                <Route exact path="/brugere/skab" component={fbgWebMasterAccess(UsersFormContainer)}/>
                <Route exact path="/brugere/redigere/:id" component={fbgWebMasterAccess(UsersFormContainer)}/>
                <Route exact path="/virksomhed" component={fbgWebMasterAccess(CompaniesListContainer)}/>
                <Route exact path="/user/delete" component={UserDeletePage}/>

                <Route exact path="/galleri" component={partnerAccess(onlyMaskinstationer(GalleryPage))}/>
                <Route exact path="/galleri/skab" component={partnerAccess(onlyMaskinstationer(GalleryFormContainer))}/>
                <Route exact path="/galleri/rediger/:id(\d+)" component={partnerAccess(onlyMaskinstationer(GalleryFormContainer))}/>
                <Route exact path="/galleri/vis/:id(\d+)" component={partnerAccess(onlyMaskinstationer(GalleryViewPage))}/>
                <Route exact path="/galleri-billede/skab/:galleryId(\d+)" component={partnerAccess(onlyMaskinstationer(GalleryImageFormContainer))}/>
                <Route exact path="/galleri-billede/rediger/:galleryId(\d+)/:id(\d+)" component={partnerAccess(onlyMaskinstationer(GalleryImageFormContainer))}/>
                <Route exact path="/galleri-billede/crop/:galleryId(\d+)/:id(\d+)" component={partnerAccess(onlyMaskinstationer(GalleryImageCropPage))}/>
                <Route exact path="/galleri-billede/rotate/:galleryId(\d+)/:id(\d+)" component={partnerAccess(onlyMaskinstationer(GalleryImageRotatePage))}/>
                {/*}
                <Route exact path="/maskine" component={partnerAccess(MachinesPage)}/>
                <Route exact path="/maskine/skab" component={partnerAccess(MachineFormContainer)}/>
                <Route exact path="/maskine/redigere/:id" component={partnerAccess(MachineFormContainer)}/>
                <Route exact path="/maskine/vis/:id" component={partnerAccess(MachineViewPageContainer)}/>
                */}
                <Route exact path="/maskine" component={partnerAccess(notMaskinbladetUser(MachinesPage))}/>
                <Route exact path="/maskine/skab" component={partnerAccess(notMaskinbladetUser(MachineFormContainer))}/>
                <Route exact path="/maskine/redigere/:id" component={partnerAccess(notMaskinbladetUser(MachineFormContainer))}/>
                <Route exact path="/maskine/vis/:id" component={partnerAccess(notMaskinbladetUser(MachineViewPageContainer))}/>

                <Route exact path="/indstillinger" component={fbgWebMasterAccess(SettingsFormContainer)}/>

                <Route exact path="/charts" component={ChartsExample}/>
                {/*<Route exact path="/statistik/total" component={allAccess(AllAnalyticsContainer)}/>*/}
                <Route exact path="/statistik/profil" component={allAccess(AnalyticsContainer)}/>
                <Route exact path="/statistik/:type" component={allAccess(notMaskinstationerMini(AnalyticsContainer))}/>
                <Route exact path="/statistik" component={allAccess(notMaskinstationerMini(AnalyticsContainer))}/>

                <Route exact path="/portal-kontakt/skab" component={fbgWebMasterAccess(PortalContactFormContainer)}/>
                <Route exact path="/portal-kontakt/redigere/:id" component={fbgWebMasterAccess(PortalContactFormContainer)}/>
                <Route exact path="/portal-kontakter" component={fbgWebMasterAccess(PortalContactTableContainer)}/>

                <Route exact path="/afdelinger/skab" component={fbgWebMasterAccess(DepartmentsFormContainer)}/>
                <Route exact path="/afdelinger/redigere/:id" component={fbgWebMasterAccess(DepartmentsFormContainer)}/>
                <Route exact path="/afdelinger" component={fbgWebMasterAccess(DepartmentsTableContainer)}/>

                <Route exact path="/tips/skab" component={fbgWebMasterAccess(TipFormContainer)}/>
                <Route exact path="/tips/redigere/:id" component={fbgWebMasterAccess(TipFormContainer)}/>
                <Route exact path="/tips" component={fbgWebMasterAccess(TipsPage)}/>

                <Route exact path="/kategorier/nyheder" component={fbgWebMasterAccess(ArticleCategoriesListContainer)}/>
                <Route exact path="/kategorier/nyheder/skab" component={fbgWebMasterAccess(ArticleCategoryFormContainer)}/>
                <Route exact path="/kategorier/nyheder/redigere/:id" component={fbgWebMasterAccess(ArticleCategoryFormContainer)}/>

                <Route exact path="/kategorier" component={superAdminAccess(CategoryTypes)}/>
                <Route exact path="/kategorier/:type" component={superAdminAccess(TreeEditorContainer)}/>
                <Route exact path="/administrer-kompetencer" component={superAdminAccess(TreeEditorCompetenciesContainer)}/>

                <Route exact path="/profil/skab" component={fbgWebMasterAccess(CompanyFormContainer)}/>
                <Route exact path="/profil/rediger" component={authenticatedAccess(CompanyFormContainer)}/>
                <Route exact path="/profil/rediger/:id" component={fbgWebMasterAccess(CompanyFormContainer)}/>
                {/*<Route exact path="/protected" component={membersAccess(Protected)}/>*/}

                <Route exact path="/interests" component={memberAccess(InterestsFormContainer)} />

                <Route exact path="/park/kategorier" component={superAdminAccess(ParkMachineCategoryPage)} />
                <Route exact path="/park/kategorier/rediger" component={superAdminAccess(ParkMachineCategoryFormContainer)} />
                <Route exact path="/park/kategorier/rediger/:id(\d+)" component={superAdminAccess(ParkMachineCategoryFormContainer)} />

                <Route exact path="/park" component={partnerAccess(onlyMaskinstationer(ParkMachinesPage))} />
                <Route exact path="/park/rediger/:id(\d+)" component={partnerAccess(onlyMaskinstationer(ParkMachineContainer))} />
                <Route exact path="/park/skab" component={partnerAccess(onlyMaskinstationer(ParkMachineContainer))} />

                <Route exact path="/rent/kategorier" component={superAdminAccess(RentMachineCategoryPage)} />
                <Route exact path="/rent/kategorier/skab" component={superAdminAccess(RentMachineCategoryFormContainer)} />
                <Route exact path="/rent/kategorier/rediger/:id(\d+)" component={superAdminAccess(RentMachineCategoryFormContainer)} />

                <Route exact path="/rent/skab" component={partnerAccess(MachineRentalFormContainer)}/>
                <Route exact path="/rent/redigere/:id(\d+)" component={partnerAccess(MachineRentalFormUpdateContainer)}/>
                <Route exact path="/rent" component={partnerAccess(RentMachinePage)}/>

                <Route exact path="/søgeordpakker/skab" component={fbgWebMasterAccess(KeywordsPackFormContainer)}/>
                <Route exact path="/søgeordpakker/rediger/:id" component={fbgWebMasterAccess(KeywordsPackFormContainer)}/>
                <Route exact path="/søgeordpakker" component={fbgWebMasterAccess(KeywordsPackPage)}/>

                <Route path="*" component={NotFound} />
            </Switch>
        </div>
    )

};

export default RoutesContainer;


// WEBPACK FOOTER //
// ./web/src/components/RoutesContainer.jsx